import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAsync, putAsync } from '../../../../components/helper/axiosHelper';
import { handleFileDownload } from '../../../../libs';
import { DetailAccordion } from '../../../external/service/sd/DetailAccordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import '../GWAStyles.css';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';

const GWARegisterApproval = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [mainData, setMainData] = useState([]);
  const [maNotes, setMaNotes] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [nationalityAPIData, setNationalityAPIData] = useState([]);
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [limitRequest, setLimitRequest] = useState(true);
  const [mediaData, setMediaData] = useState([]);

  const { id } = useParams();
  const { t } = useTranslation();
  const epUser = localStorage.getItem('apid');
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    isLogin();
    getEPUserData();
    getNationality();
    getCountries();
  }, []);

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const getEPUserData = async () => {
    setIsLoading(true);
    await getAsync('GWAService/GetGWAServiceById', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      id: id,
    })
      .then((response) => {
        setIsLoading(false);
        setMainData(response?.data[0]);
        setMediaData(response?.data[0]?.archiveMediaModelList);
      })
      .catch((err) => {
        toast.error(`${t('msg_errorDueTo')}: ${err.message}`);
      });
  };

  const bodyApproved = {
    ePUserID: mainData?.epUserID,
    gwaServiceID: parseInt(mainData?.gwaServiceID),
    maid: parseInt(epUser),
    userId: epUser,
    maApproveID: 1,
    maNotes: maNotes,
    password: password,
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (maNotes !== null && maNotes !== '') {
      await putAsync('GWAService/GWARegisterApproval/', bodyApproved, {
        id: id,
      })
        .then((response) => {
          setIsLoading(false);
          if (response?.statusCode === 200) {
            toast.success(`${t('Approved Successfully')}`);
            setMaNotes('');
            navigate('/GWARegisterApprovalList');
          } else {
            toast.error(`${t('Password failed Please try Again')}`);
          }
        })
        .catch((err) => {
          toast.error(`${t('msg_errorDueTo')}: ${err.message}`);
        });
    } else {
      toast.error(t('Please Fill the Manage Notes'));
      setIsLoading(false);
    }
  };
  const bodyDisApproved = {
    ePUserID: mainData?.epUserID,
    gwaServiceID: parseInt(mainData?.gwaServiceID),
    maid: parseInt(epUser),
    userId: epUser,
    maApproveID: 2,
    maNotes: maNotes,
    password: password,
  };

  const handleDisapprove = async (e) => {
    e.preventDefault();
    if (maNotes !== null && maNotes !== '') {
      setIsLoading(true);
      await putAsync('GWAService/GWARegisterApproval/', bodyDisApproved, { id: id })
        .then((response) => {
          setIsLoading(false);
          if (response?.statusCode === 200) {
            toast.success(`${t('Disapproved Successfully')}`);
            setMaNotes('');
            navigate('/GWARegisterApprovalList');
          } else {
            toast.error(`${t('Password failed Please try Again')}`);
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    } else {
      toast.error(t('Please Fill the MA Notes'));
    }
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList', {
      id: id,
    })
      .then((response) => {
        setCountryAPIData(response?.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getNationality = async () => {
    await getAsync('Utilities/GetNationalityList')
      .then((response) => {
        setNationalityAPIData(response.data);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleDocLoad = async (e) => {
    e.preventDefault();
    setLimitRequest(false);
  };
  const foundNationality = nationalityAPIData?.find(
    (element) => element?.settingsNationalityID == mainData?.nationalityID,
  );

  const foundCountry = countryAPIData?.find((element) => element?.countryID == mainData?.residentCountryID);

  return (
    <>
      <div className=" flex justify-center py-5 mt-3">
        <div className="w-full  ">
          <form className="container mx-auto">
            <div className="  shadow-md rounded-lg">
              <div className=" text-center">
                <h1 className="font-bold text-2xl text-customgreen">
                  {t('Goodwill Ambassador Registration Approval')}
                </h1>
              </div>

              {isLoading ? (
                <LoadingAnimation />
              ) : (
                <>
                  <div className="card-body md:p-10">
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Personal Details')}</h2>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography></Typography>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group ">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('User Type')} <span className="errmsg">*</span>
                              </label>
                              <br />
                              <label
                                style={{ margin: '10px' }}
                                className="text-gray-700 p-2 font-semibold text-pretty text-sm"
                              >
                                <input
                                  disabled
                                  style={{ marginRight: '5px' }}
                                  type="radio"
                                  defaultChecked={mainData?.gwaTypeID == 1 ? true : false}
                                  name="userType"
                                  value={mainData?.gwaTypeID}
                                />
                                {t('Institute')}
                              </label>
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                <input
                                  disabled
                                  style={{ marginRight: '5px' }}
                                  type="radio"
                                  name="userType"
                                  defaultChecked={mainData?.gwaTypeID == 2 ? true : false}
                                  value={mainData?.gwaTypeID}
                                />
                                {t('Personal')}
                              </label>
                            </div>
                          </div>

                          {mainData?.gwaTypeID == 2 && (
                            <div className="col-lg-6 mb-4">
                              <div className="form-group">
                                <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                  {t('Workplace')}
                                  <span className="errmsg">*</span>
                                </label>
                                <input
                                  value={mainData?.workPlace}
                                  disabled
                                  type="text"
                                  className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="row">
                          <div className="col-lg-6 mb-4">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Nationality')} <span className="errmsg">*</span>
                              </label>
                              {foundNationality && (
                                <input
                                  value={isActive ? foundNationality.nationality_t : foundNationality.nationality_eng}
                                  disabled
                                  type="text"
                                  className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                                />
                              )}
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Resident Country')}
                                <span className="errmsg">*</span>
                              </label>
                              {foundCountry && (
                                <input
                                  value={isActive ? foundCountry.ar_SA : foundCountry?.en_US}
                                  disabled
                                  type="text"
                                  className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <br />

                    <DetailAccordion
                      handleDocLoad={handleDocLoad}
                      mediaData={mediaData}
                      handleFileDownload={handleFileDownload}
                      title={'Document Details'}
                    />
                    <br />

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Account Details')}</h2>
                      </AccordionSummary>
                      <AccordionDetails className="px-4">
                        {/* <Typography style={ { fontWeight: 'bold', fontSize: '18px' } }>
                          { t('Confirmation') }
                        </Typography> */}
                        <div className="row ">
                          <div className=" mb-4 px-0">
                            <div className="form-group">
                              <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                                {t('Website')}
                              </label>
                              <input
                                value={mainData.website}
                                disabled
                                type="text"
                                className="border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen readonly"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row overflow-x-auto  ">
                          <table className="table w-full  ">
                            <thead className="text-gray-200 font-medium text-sm uppercase bg-customgreen">
                              <tr>
                                <td className="py-3  text-center capitalize   p-2  text-white whitespace-nowrap">
                                  {t('sNo')}
                                </td>
                                <td className="py-3  text-center  p-2 text-white  whitespace-nowrap">
                                  {t('Account Name')}
                                </td>
                                <td className="py-3 text-center p-2 text-white  whitespace-nowrap">
                                  {t('Account Title')}
                                </td>
                              </tr>
                            </thead>
                            {mainData?.accountHandelMappingList?.map((item, index) => (
                              <tbody className="text-gray-700 text-sm" key={index}>
                                <tr>
                                  <td className="py-3 text-center p-2">{index + 1}</td>
                                  <td className="py-3  text-center p-2">{item.accountName}</td>
                                  <td className="py-3  text-center p-2">{t(`${item.siteName}`)}</td>
                                </tr>
                              </tbody>
                            ))}
                          </table>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <br />
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Extra')}</h2>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography></Typography>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                              {t('Reason')} <span className="errmsg">*</span>
                            </label>
                            <textarea
                              style={{ height: '100px' }}
                              value={mainData?.regReason}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              minLength="1"
                              maxLength="500"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                              {t('Managed Notes')} <span className="errmsg">*</span>
                            </label>
                            <textarea
                              style={{ height: '100px' }}
                              value={maNotes}
                              onChange={(e) => setMaNotes(e.target.value)}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              minLength="1"
                              maxLength="500"
                            />
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                    <br />

                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Confirmation')}</h2>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography></Typography>
                        {/* <h3>{ t('Enter Password To Confirm Password') }</h3> */}
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="text-gray-700 p-2 font-semibold text-pretty text-sm">
                              {t('Password')}
                              <span className="errmsg">*</span>
                            </label>
                            <input
                              value={password}
                              type="password"
                              onChange={(e) => setPassword(e.target.value)}
                              className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              minLength="1"
                              maxLength="50"
                            />
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  {/* buttons */}
                  <div className="flex flex-wrap gap-2 justify-center items-center space-x-2 xss:py-5 ">
                    <button
                      type="submit"
                      onClick={handleApprove}
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    >
                      {t('Approve')}
                    </button>
                    <button
                      type="submit"
                      onClick={handleDisapprove}
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    >
                      {t('Disapprove')}
                    </button>
                    <Link
                      to={'/GWARegisterApprovalList'}
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                    >
                      {t('Back')}
                    </Link>
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default GWARegisterApproval;
